import React, {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Block, FormGroup, Title, useForm} from "../../../../components/components";
import FormButton from "../../../../components/forms/FormButton";
import {useGetUserQuery, useUpdateUserMutation} from "../../../../api/userApiSlice";
import {DataVendorUserForm} from "../../../../components/data_vendors/DataVendorUserForm";

function EditUser(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { userId } = useParams();
  const {data: user, isSuccess} = useGetUserQuery(userId)
  const [updateUser] = useUpdateUserMutation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const goToUser = () => history.push(`/users/${userId}`)

  const handleSubmit = (data) => {
    updateUser({user: {...data, userId}}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  if (!isSuccess) { return (<></>) }
  return (
    <>
      <Title main={t("menu.users")} sub={`${user.firstName} ${user.lastName}`} group={false} onBack={goToUser}>
        <FormButton submit {...submitButtonProps}/>
        <FormButton cancel onClick={goToUser} />
      </Title>
      <DataVendorUserForm
        user={user}
        handleSubmit={handleSubmit}
        setSubmitButtonProps={setSubmitButtonProps}
        canSelectRole={false}
      />
    </>
  )
}

export default EditUser
